import { Swiper } from 'swiper/bundle'

/**
 * @param {string} selector
 * @param {object} swiperConfig
 */
export function initSwiperOnView(selector, swiperConfig) {
  const elements = document.querySelectorAll(selector)
  if (!('IntersectionObserver' in window)) {
    // Fallback: init all immediately if IntersectionObserver is not supported
    elements.forEach((el) => {
      const htmlEl =
        /** @type {HTMLElement & { _swiperInitialized?: boolean }} */ (el)
      if (!htmlEl._swiperInitialized) {
        new Swiper(htmlEl, swiperConfig)
        htmlEl._swiperInitialized = true
      }
    })
    return
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        const htmlEl =
          /** @type {HTMLElement & { _swiperInitialized?: boolean }} */ (
            entry.target
          )
        if (entry.isIntersecting && !htmlEl._swiperInitialized) {
          new Swiper(htmlEl, swiperConfig)
          console.info('swiper init for', htmlEl)
          htmlEl._swiperInitialized = true
          obs.unobserve(entry.target)
        }
      })
    },
    { threshold: 0.1 },
  )

  elements.forEach((el) => observer.observe(el))
}
